import Vue from 'vue'
import 'vant/lib/button/style'
import 'vant/lib/nav-bar/style';
import 'vant/lib/notice-bar/style';
import 'vant/lib/popup/style';
import 'vant/lib/dropdown-menu/style';
import 'vant/lib/dropdown-item/style';
import 'vant/lib/toast/style';
import 'vant/lib/dialog/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/field/style';
import 'vant/lib/icon/style';
import 'vant/lib/row/style';
import 'vant/lib/col/style';
import 'vant/lib/image/style';
import 'vant/lib/action-sheet/style';
import {
  Button,
  Popup,
  DropdownMenu,
  DropdownItem,
  NavBar,
  NoticeBar,
  Dialog,
  DatetimePicker,
  Field,
  Icon,
  Row,
  Col,
  Image,
  ActionSheet
} from 'vant'

Vue.use(Button)
Vue.use(Popup)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(NoticeBar)
Vue.use(NavBar)
Vue.use(Dialog)
Vue.use(DatetimePicker)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(ActionSheet)